import { styled } from '@mui/material';

export const ReelBar = styled('div')`
  height: 150px;
  width: ${({ width }: { width: number }) => width + 'px' || '100%'};
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  overflow-x: scroll;
  z-index: -1;
  -webkit-transition: height 0.3s ease;
  transition: height 0.3s ease;

  &::-webkit-scrollbar-track {
    background: #292929;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #ea475c;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 8px;
    background: #292929;
  }

  .scroll-div {
    width: auto;
    height: 100%;
  }
`;

export const CategoriesStyled = styled('div')`
  margin-top: 5px;
  span {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50px;
    color: #fff;
    padding: 5px 25px;
    font-size: 14px;
    margin: 0 5px;
    margin-bottom: 5px;
    display: inline-block;
    white-space: nowrap;
    &:hover {
      opacity: 0.5;
    }
  }
`;
export interface CategorySpanInterface {
  activeCategory: number;
}
export const CategorySpan = styled('span')<CategorySpanInterface>(({}) => ({
  root: {
    opacity: ({ activeCategory, id }: { activeCategory: number; id: number }) =>
      activeCategory === id && 0.5
  }
}));
//
export const Preview = styled('div')`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 106px;
  width: 160px;
  margin: 0 5px;
  margin-top: 6px;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  position: relative;
  overflow: hidden;
`;
